import Immutable from "immutable";

export default {
    CLEAR_WIDGETS_UISTATE: (state, action) => {
        let cachedWidgets = action.payload.cachedWidgets || {};
        //removing all uiState
        return state.filter((widgetData, widgetKey) => {
            return cachedWidgets[widgetKey];
        });
    },
    CLEAR_WIDGET_UISTATE: (state, action) => {
        let widgetId = action.payload.widgetId;

        let newState = state.filter((widgetData, widgetKey) => {
            return widgetKey !== widgetId;
        });
        return newState;
    },
    CLEAR_DASHBOARD_UISTATE: (state, action) => {
        return state.deleteIn(["dashboards", "current"]);
    },
    SET_UISTATES: (state, action) =>
        state.withMutations(mutableState =>
            action.payload.forEach(entity => {
                mutableState.mergeIn(entity.path, entity.state);
            })
        ),
    SET_UISTATE: (state, action) => {
        let widgetId = action.payload.widgetId;
        let componentId = action.payload.componentId;
        let newUiState = action.payload.newState;
        //newUiState is merged
        return state.mergeIn([widgetId, componentId], Immutable.fromJS(newUiState));
    },
    CLEAR_UISTATE: (state, action) => {
        let widgetId = action.payload.widgetId;
        let componentId = action.payload.componentId;
        return state.deleteIn([widgetId, componentId]);
    },
    CLEAR_WIDGET_ENTITIES_UI_VALIDATION_STATE: (state, action) => {
        let widgets = action.payload.widgets || [];
        return state.withMutations(mutableState =>
            widgets.forEach(widget => {
                let childNodes = state.get(widget);
                if (childNodes) {
                    let childNodesSequence = childNodes.keySeq().toArray();
                    let currentNode;
                    for (let i = 0; i < childNodesSequence.length; i++) {
                        currentNode = childNodesSequence[i];
                        let stateData = state
                            .getIn([widget, currentNode])
                            .keySeq()
                            .toArray();
                        if (stateData.includes("valid")) {
                            mutableState.deleteIn([widget, currentNode, "valid"]);
                            mutableState.deleteIn([widget, currentNode, "failedValidations"]);
                        }
                    }
                }
            })
        );
    },
    CLEAR_UISTATE_DEEP: (state, action) => {
        let newState = state;
        let widgetId = action.payload.widgetId;
        let childNodes = state
            .get(widgetId)
            .keySeq()
            .toArray();
        let currentNode;
        let componentId = action.payload.componentId;
        for (let i = 0; i < childNodes.length; i++) {
            currentNode = childNodes[i];
            if (currentNode.indexOf(componentId) === 0) {
                newState = newState.deleteIn([widgetId, currentNode]);
            }
        }
        return newState;
    },
    CLEAR_UISTATE_VALIDATIONS_DEEP: (state, action) => {
        let newState = state;
        let widgetId = action.payload.widgetId;
        let childNodes = state
            .get(widgetId)
            .keySeq()
            .toArray();
        let currentNode;
        let componentId = action.payload.componentId;
        for (let i = 0; i < childNodes.length; i++) {
            currentNode = childNodes[i];
            if (currentNode.indexOf(componentId) === 0) {
                let stateData = state
                    .getIn([widgetId, currentNode])
                    .keySeq()
                    .toArray();
                if (stateData.includes("valid")) {
                    newState = newState.deleteIn([widgetId, currentNode, "valid"]);
                    newState = newState.deleteIn([widgetId, currentNode, "failedValidations"]);
                }
            }
        }
        return newState;
    }
};
